import React from "react";

function CoachMetricCard({ taskSaveManagementDetails }) {
  const taskSave = taskSaveManagementDetails?.getTaskSaveList?.[0];
  const metricId = taskSave?.MetricId;

  const agentMetricData =
    taskSaveManagementDetails?.getAgentDbMetricsData?.find(
      (x) => x.metricid === metricId,
    );

  const taskRecord =
    taskSaveManagementDetails?.getTaskManagerRecordsDataByRecordID;

  return (
    <div className="card">
      <div
        className="card-header"
        style={{
          backgroundColor: taskSave?.taskcolor || "#FFE9A8",
          fontWeight: "bold",
        }}
      >
        {taskSaveManagementDetails?.taskSaveManagermetricName}
      </div>

      <div className="card-body">
        <div className="d-flex space-between">
          <div>
            <span className="acthd">Actual on Task Created:</span>
            <span className="actval">{taskRecord?.actualontaskcreated}</span>
          </div>

          <div>
            <span className="acthd">Actual on Today:</span>
            <span className="actval">{agentMetricData?.actual}</span>
          </div>
        </div>

        <div className="flex space-between start_end_date">
          <span>
            {taskSave?.createdDate
              ? new Date(taskSave.createdDate).toLocaleDateString()
              : ""}
          </span>

          <span>{new Date().toLocaleDateString()}</span>
        </div>
      </div>
    </div>
  );
}

export default CoachMetricCard;
